import Head from 'next/head';
import SiteLayout from '@/components/layout/SiteLayout';
import { AuszeichnungenSection } from '@/components/sections/AuszeichnungenSection';
import { auszeichnungen } from '@/lib/content/veroeffentlichungen';

const seo = {
  title: 'Marlene Gujan Architektur AG | Auszeichnungen',
  description: 'Entdecken Sie die Auszeichnungen und Ehrungen der Marlene Gujan Architektur AG in Igis für herausragende Leistungen in der Architektur.',
  keywords: 'Auszeichnungen, Ehrungen, Marlene Gujan, Architektur, Igis, Leistungen',
  canonicalUrl: 'https://www.gujan-architektur.ch/buero/auszeichnungen',
};

export default function Auszeichnungen({ data }) {
  return (
    <SiteLayout>
      <Head>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={seo.canonicalUrl} />
      </Head>
      <AuszeichnungenSection data={data} />
    </SiteLayout>
  );
}

export async function getStaticProps() {
  return { props: { data: await auszeichnungen() }, revalidate: 300 };
}
